import http from 'utils/http';
import { notification } from 'antd';

export const getRules = async (params) => {
  try {
    const response = await http.get('/payment/routing', { params });
    return response?.data?.data;
  } catch (err) {}
};
export const createRule = async (store_id, payload) => {
  try {
    const response = await http.post(`/payment/routing?store_id=${store_id}`, payload);
    return response?.data?.data;
  } catch (err) {
    notification.error({ message: err?.response?.data?.message || 'NETWORK ERROR', placement: 'bottomRight' });
  }
};
export const updateRule = async (rule_id, store_id, payload) => {
  try {
    const response = await http.patch(`/payment/routing/${rule_id}?store_id=${store_id}`, payload);
    return response?.data?.data;
  } catch (err) {
    notification.error({ message: err?.response?.data?.message || 'NETWORK ERROR', placement: 'bottomRight' });
  }
};
export const deleteRule = async (rule_id, store_id) => {
  try {
    const response = await http.delete(`/payment/routing/${rule_id}?store_id=${store_id}`);
    return response?.data?.data;
  } catch (err) {
    notification.error({ message: err?.response?.data?.message || 'NETWORK ERROR', placement: 'bottomRight' });
  }
};
